module.exports = "/images/vendor/flag-icon-css/flags/4x3/cc.svg?2da4bb974f777f45e0398ac1ba44e507";